module.exports = __webpack_public_path__ + "media/33.d4b3a6d7.mp3";